import styles from "./Tips.module.css";

type Props = {
  body: string;
};

export const Tips = (props: Props) => {
  return <div className={styles.container}>{props.body}</div>;
};
